import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';
import { getContext, setContext } from 'svelte';
import { StoreKeys } from './StoresKeys';

const fullFeedInStore = writable<boolean>(false);

export const useFullFeedIn = (initialValues?: boolean) => {
	if (initialValues) {
		fullFeedInStore.set(initialValues);
	}

	const setFullFeedInStore = () => {
		setContext(StoreKeys.FULL_FEED_IN, fullFeedInStore);
	};

	return {
		setFullFeedInStore,
		...fullFeedInStore
	};
};

export const getFullFeedInStore = (): Writable<boolean> => {
	return getContext(StoreKeys.FULL_FEED_IN);
};
